import { render } from "./CourseContentBrowser.vue?vue&type=template&id=6d01db08&scoped=true"
import script from "./CourseContentBrowser.vue?vue&type=script&lang=js"
export * from "./CourseContentBrowser.vue?vue&type=script&lang=js"

import "./CourseContentBrowser.vue?vue&type=style&index=0&id=6d01db08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d01db08"]])

export default __exports__